export class TypeVoie {

	public typevoie: string;

	public num: string;

	public nomvoie: string;

	constructor() { 
		this.typevoie = '';
		this.num = '';
		this.nomvoie = '';
	}
}